import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassReportComment extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassReportComment'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      compassReportId: null,
      userId: null,
      comment: '',
      parentCommentId: null,
      userName: '',
      nodeUuid: '',
      sessionKey: '',
    }
  }
}
const servicePath = 'compass-reports-comments'
const servicePlugin = makeServicePlugin({
  Model: CompassReportComment,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [
      // Hook to ensure sessionKey is sent to the server
      context => {
        // If this is a guest user deleting a comment with a sessionKey,
        // make sure it's available in the query params
        if (context.params && context.params.query && context.params.query.sessionKey) {
          // The sessionKey is already in the query, nothing to do
          return context
        }

        return context
      },
    ],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
